var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "800px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [_c("v-icon", [_vm._v("clear")]), _vm._v(" Advertencia\n    ")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { md12: "" } },
                    [
                      _c("v-textarea", {
                        staticClass: "v_card",
                        attrs: {
                          rows: "2",
                          label: "Justificación de la anulación",
                          "background-color": "rgba( 117, 109, 194 ,0.4)",
                          rules: _vm.$validate(["required"]),
                          required: "",
                          outline: "",
                          success: "",
                          clearable: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.encenderBandera()
                          }
                        },
                        model: {
                          value: _vm.justificacion_rechazo,
                          callback: function($$v) {
                            _vm.justificacion_rechazo = $$v
                          },
                          expression: "justificacion_rechazo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("h3", [_vm._v("¿Desea anular el permiso?")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("h4", [_vm._v("Nota: Esta acción es irreversible")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "error" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close()
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "success",
                    loading: _vm.loading,
                    disabled: _vm.bandera_justificacion == false
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.anularControlPermiso()
                    }
                  }
                },
                [_vm._v("\n        Anular\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42889b3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42889b3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/dialogs/AnularPermiso.vue
// module id = null
// module chunks = 